import supabase from "../../../core/supabase/supabase";
import { ReceivedTime } from "../interfaces/receivedTime";

export async function getTime(matchId: number): Promise<ReceivedTime> {
  const data = await supabase.matchChronology.getRow(matchId)
  return { seconds: data?.seconds ?? 0, currentPeriod: data?.currentPeriod ?? 1 }
}
